//import all repository here
import AuthRepository from './auth/authRepository'
import PartnerRepository from './business/partnerRepository';
import Prospect from './business/Prospect';
import JoinUsRepository from './business/joinUsRepository';
import PropertyRepository from './travel/propertyRepository';
import PackageRepository from './travel/packageRepository';
import PriceRepository from './travel/priceRepository';
import QaRepository from './events/qaRepository';
import ExchangeRepository from './events/exchangeRepository';
import SeoRepository from './events/SeoRepository';
import EnquiryRepository from './events/enquiryRepository';
import BookingRepository from './travel/bookingRepository';
import InvoiceRepository from './travel/invoiceRepository';
import PaymentRepository from './travel/PaymentRepository';
import CustomerRepository from './business/customerRepository';
import SubscriptionRepository from './events/subscriptionRepository';
import SupportRepository from './events/supportRepository';
import CommonRepository from './commonRepository';
import DashboardRepository from "./dashboardRepository";
import BankRepository from "./bankRepository";
import PartnersBankAccountsRepository from "./partnersBankAccountsRepository";
import PaymentDetailsRepository from "./events/paymentDetailsRepository";
import OptionalRepository from "./travel/OptionalRepository";

import MiscTask from './Misc';

//define key for all repository
const repositories = {
  'auth' : AuthRepository,
  'partner': PartnerRepository,
  'join_us': JoinUsRepository,
  'property' : PropertyRepository,
  'package': PackageRepository,
  'price': PriceRepository,
  'seo' : SeoRepository,
  'qa' : QaRepository,
  'exchange' : ExchangeRepository,
  'enquiry' : EnquiryRepository,
  'booking' : BookingRepository,
  'invoice' : InvoiceRepository,
  'payment' : PaymentRepository,
  'customer' : CustomerRepository,
  'common': CommonRepository,
  'subscription': SubscriptionRepository,
  'support': SupportRepository,
  'dashboard': DashboardRepository,
  'bank': BankRepository,
  'partners_bank_accounts': PartnersBankAccountsRepository,
  'paymentDetails': PaymentDetailsRepository,
  'prospect': Prospect,
  'misc': MiscTask,
  'optionals': OptionalRepository,
};

//Common for all repository
export default {
  get: name => repositories[name]
};



// WEBPACK FOOTER //
// ./src/repositories/repositoryFactory.js